import React, {useRef, useEffect} from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from 'antd';

import SingleDeviceHeader from "../SingleDeviceHeader";
import GatewayDeviceDashboard from "./gateway";
import BLEDeviceDashboard from "./ble";
import DeviceDashboardHeader from "./common/header";

import { useDispatch, useSelector } from "react-redux";
import { fetchDeviceRequest } from "../../../store/actions/singleDeviceHeader";

function ViewDeviceDashboard() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const fullScreenRef = useRef();
  const isDeviceDataLoading = useSelector((state) => state.singleDeviceHeader.isLoading);
  const isBLE = useSelector((state) => state.singleDeviceHeader.isBLE);
  const isRefresh = useSelector((state) => state.deviceDashboard.isRefresh);
  const isFullScreenMode = useSelector((state) => state.deviceDashboard.isFullScreenMode);
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(fetchDeviceRequest({
      id
    }));
  }, [dispatch, id, user?.accountId])

  return (
    <div ref={fullScreenRef}  className={isFullScreenMode ? "view-device-dashboard-wrapper p-4 ats-fullscreen-scroll" : "view-device-dashboard-wrapper"} >
      {isDeviceDataLoading && <Skeleton paragraph={{ rows: 2 }} />}
      {!isDeviceDataLoading && isBLE !== null && <SingleDeviceHeader isBLE={isBLE}/> }
      <DeviceDashboardHeader id={id} parentRef={fullScreenRef} pageTitle={isBLE ? "BLE Tag" : "Gateway"}/>
      {isDeviceDataLoading && <div className="view-device-dashboard-full"><Skeleton paragraph={{ rows: 25 }}/></div>}
      {(isBLE === true && !isDeviceDataLoading)  && <BLEDeviceDashboard id={id} isRefresh={isRefresh}/>}
      {(isBLE === false && !isDeviceDataLoading) && <GatewayDeviceDashboard id={id} isRefresh={isRefresh}/>}
    </div>
  );
}

export default ViewDeviceDashboard;
